import type { Image } from '@ps/web-martech-cms-types';
import React from 'react';

import { CMSImage } from '@swf/cms';

import styles from './Tile.scss';

interface Props {
  image: Image;
  text?: string;
}

const Tile: React.FC<Props> = ({ image, text = '' }) => (
  <div className={styles.root}>
    <CMSImage className={styles.image} {...image} />
    <p className={styles.text}>{text}</p>
  </div>
);

export default Tile;
